__turbopack_context__.v({
  "breakline": "Blb7-W_breakline",
  "card": "Blb7-W_card",
  "card-content": "Blb7-W_card-content",
  "card-grid": "Blb7-W_card-grid",
  "card-info": "Blb7-W_card-info",
  "card-text-subtitle": "Blb7-W_card-text-subtitle",
  "card-text-title": "Blb7-W_card-text-title",
  "container-grid": "Blb7-W_container-grid",
  "grid-wrapper": "Blb7-W_grid-wrapper",
  "phone-number-grid-card": "Blb7-W_phone-number-grid-card",
  "phone-number-grid-separator": "Blb7-W_phone-number-grid-separator",
  "phone-number-title-divider": "Blb7-W_phone-number-title-divider",
  "section": "Blb7-W_section",
  "section-breakline": "Blb7-W_section-breakline",
  "title-divider-wrapper": "Blb7-W_title-divider-wrapper",
  "title-typography": "Blb7-W_title-typography",
  "typography": "Blb7-W_typography",
});
